/* ----------- RESOURCES  ----------- */
import { StrictMode } from "react";
import ReactDOM from "react-dom";

import reportWebVitals from "./reportWebVitals";
import App from "pages/__app";

import "leaflet/dist/leaflet.css";

ReactDOM.render(
    <StrictMode>
        <App />
    </StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
process.env.NODE_ENV === "development" && reportWebVitals();
